import { especialidades } from '../data/conteudo';
import styles from './Especialidades.module.css';

const Especialidades = () => (
  <section id="especialidades" className="secao secao-rosada" aria-labelledby="titulo-especialidades">
    <div className="container">
      <div className={styles.topo}>
        <h2 id="titulo-especialidades">Especialidades</h2>
        <p>
          Cada atendimento parte da sua história e dos seus objetivos. Conheça as áreas em que posso
          te acompanhar.
        </p>
      </div>

      <ul className={styles.lista}>
        {especialidades.map((item) => (
          <li key={item.titulo}>
            <h3>{item.titulo}</h3>
            <p>{item.descricao}</p>
          </li>
        ))}
      </ul>
    </div>
  </section>
);

export default Especialidades;
